import * as tslib_1 from "tslib";
/** @jsx jsx */

import { jsx } from "@emotion/core";
import { Text } from "./Text";
import PropTypes from "prop-types";
import { MenuLabel } from "./Menu";
import { useTheme } from "./Theme/Providers";
import { noOp } from "./misc/noop";
export var List = function List(_a) {
  var children = _a.children,
      other = tslib_1.__rest(_a, ["children"]);

  return jsx("nav", tslib_1.__assign({}, other), children);
};
List.propTypes = {
  children: PropTypes.node
};
export var ListItem = function ListItem(_a) {
  var primary = _a.primary,
      secondary = _a.secondary,
      contentBefore = _a.contentBefore,
      _b = _a.interactive,
      interactive = _b === void 0 ? true : _b,
      children = _a.children,
      _c = _a.wrap,
      wrap = _c === void 0 ? true : _c,
      contentAfter = _a.contentAfter,
      _d = _a.component,
      Component = _d === void 0 ? "div" : _d,
      other = tslib_1.__rest(_a, ["primary", "secondary", "contentBefore", "interactive", "children", "wrap", "contentAfter", "component"]);

  var _e, _f;

  var interactiveProps = interactive ? {
    role: "button",
    tabIndex: 0
  } : {};
  var theme = useTheme();
  return jsx(Component, tslib_1.__assign({
    className: "ListItem",
    onTouchStart: noOp,
    css: [(_e = {
      display: "block",
      textDecoration: "none",
      outline: "none",
      padding: theme.spaces.md,
      background: "transparent",
      WebkitTapHighlightColor: "transparent",
      transition: "background 0.07s ease"
    }, _e[theme.mediaQueries.md] = {
      paddingLeft: theme.spaces.lg,
      paddingRight: theme.spaces.lg
    }, _e[":last-child"] = {
      borderBottom: "none"
    }, _e), interactive && (_f = {
      cursor: "pointer",
      ":active": {
        background: theme.colors.background.tint1
      },
      ":focus": {
        background: theme.colors.background.tint1
      }
    }, _f["@media (hover: hover)"] = {
      ":hover": {
        background: theme.colors.background.tint1
      },
      ":active": {
        background: theme.colors.background.tint2
      }
    }, _f)]
  }, interactiveProps, other), jsx("div", {
    className: "ListItem__container",
    css: {
      display: "flex",
      alignItems: "center"
    }
  }, contentBefore && jsx("div", {
    className: "ListItem__content-before",
    css: {
      marginRight: theme.spaces.md
    }
  }, contentBefore), jsx("div", {
    className: "ListItem__content",
    css: {
      flex: 1,
      overflow: "hidden"
    }
  }, jsx(Text, {
    className: "ListItem__primary",
    wrap: wrap,
    variant: "body",
    css: {
      display: "block",
      fontWeight: 500
    }
  }, primary), secondary && jsx(Text, {
    className: "ListItem__secondary",
    wrap: wrap,
    css: {
      display: "block",
      fontSize: theme.fontSizes[0]
    },
    variant: "body",
    muted: true
  }, secondary), children), contentAfter && jsx("div", {
    className: "ListItem__content-after",
    css: {
      flex: "0 0 auto",
      marginLeft: theme.spaces.md
    }
  }, contentAfter)));
};
ListItem.propTypes = {
  primary: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  secondary: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  contentBefore: PropTypes.node,
  contentAfter: PropTypes.node,
  wrap: PropTypes.bool,
  children: PropTypes.node,
  interactive: PropTypes.bool
};
export var ListSection = function ListSection(_a) {
  var title = _a.title,
      children = _a.children,
      _b = _a.sticky,
      sticky = _b === void 0 ? true : _b,
      other = tslib_1.__rest(_a, ["title", "children", "sticky"]);

  var _c;

  var theme = useTheme();
  var bg = theme.colors.background.layer;
  return jsx("div", {
    css: {
      ":first-child > *": {
        borderTop: "none"
      }
    }
  }, jsx(MenuLabel, tslib_1.__assign({
    css: (_c = {
      position: sticky ? "sticky" : "static",
      top: 0,
      backgroundColor: sticky ? bg : "transparent",
      padding: theme.spaces.sm,
      paddingLeft: theme.spaces.md,
      marginTop: theme.spaces.md
    }, _c[theme.mediaQueries.md] = {
      paddingLeft: theme.spaces.lg,
      paddingRight: theme.spaces.lg
    }, _c)
  }, other), title), children);
};
ListSection.propTypes = {
  title: PropTypes.string.isRequired,
  sticky: PropTypes.bool,
  children: PropTypes.node
};